import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from './storage/local-storage.service';
import { LocalStorageVariables } from '../enum/localstorage-variables';

@Injectable({
  providedIn: 'root'
})
export class RecentlySearchedService {
  private localStorageService = inject(LocalStorageService);

  private maxItems = 5;

  private save(keywords: string[]) {
    this.localStorageService.setItem(
      LocalStorageVariables.storage_key,
      JSON.stringify(keywords)
    );
  }

  addKeyword(keyword: string): void {
    let keywords = this.getKeywords();

    // Remove the keyword if it already exists
    keywords = keywords.filter((k) => k !== keyword);

    // Add the keyword at the beginning of the array
    keywords.unshift(keyword);

    // Limit the number of items stored
    if (keywords.length > this.maxItems) {
      keywords.pop();
    }

    this.save(keywords);
  }

  getKeywords(): string[] {
    const storedKeywords = this.localStorageService.getItem(
      LocalStorageVariables.storage_key
    );
    return storedKeywords ? JSON.parse(storedKeywords) : [];
  }

  removeKeyword(index: number) {
    const keywords = this.getKeywords();
    keywords.splice(index, 1);
    this.save(keywords);
    return keywords;
  }
}
